module.exports = __webpack_public_path__ + "static/media/Jizni_svahy.21bb4910.md";